'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2;
var ContentSubHeader = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  align-items: center;\n  background-color: white;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  padding: 1rem;\n\n  @media screen and (max-width: 768px) {\n    padding: 1.5rem 1rem;\n  }\n"])), bumbag.palette('white900'));
var Container = bumbag.styled(bumbag.Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media screen and (max-width: 768px) {\n    align-items: unset;\n    flex-direction: column;\n\n    & > *:not(:last-child) {\n      margin-bottom: 1rem;\n    }\n  }\n"])));

function SubHeader(props) {
  var children = props.children,
      minWidthBreakpoint = props.minWidthBreakpoint;
  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'Flexible... Remove this comment to see the full error message
    React__default["default"].createElement(ContentSubHeader, _extends__default["default"]({
      border: true
    }, props), /*#__PURE__*/React__default["default"].createElement(Container, {
      breakpoint: minWidthBreakpoint,
      isFluid: !minWidthBreakpoint
    }, children))
  );
}

SubHeader.defaultProps = {
  minWidthBreakpoint: undefined
};

exports["default"] = SubHeader;
